export default __webpack_public_path__ + "static/ring9-9ecedbeee664686a342576554c93a2de.png";